import React from "react";
import "../styles/global.css";

import DavisTate from "../assets/davistate.jpg";
import Goodfellows from "../assets/goodfellows.jpg";
import HawesandCo from "../assets/hawesandco.jpg";

const Home = () => {
  return (
    <main className="container">
      <div className="welcome-text">
        <p>
          Welcome to Southern Homemove
        </p>
      </div>
      <div className="intro-text">
        <p>
          Southern Homemove provides superior residential sales, residential lettings and property management services to the real estate industry.
          <br />
          With a network of branches across South West London, Surrey, Oxfordshire, and Berkshire, we are committed 
          to providing exceptional service and expertise to our clients.
        </p>
      </div>
      <div className="button-group">
        <div className="button-with-image">
          <a href="https://www.davistate.com/">
            <img src={DavisTate} alt="Davis Tate" className="button-image" />
          </a>
        </div>
        <div className="button-with-image">
          <a href="https://www.goodfellows.co.uk/">
            <img src={Goodfellows} alt="Goodfellows" className="button-image" />
          </a>
        </div>
        <div className="button-with-image">
          <a href="https://www.hawesandco.co.uk/">
            <img src={HawesandCo} alt="Hawes & Co" className="button-image" />
          </a>
        </div>
      </div>
    </main>
  );
};

export default Home;
